import { useCallback, useMemo } from 'react';

import { SupportedCurrency } from '__generated__/globalTypes';
import { useCurrentUserContext } from 'contexts/currentUser';
import { AcceptedCurrenciesValue } from 'hooks/useAcceptedCurrencies';
import { useCurrentUserAcceptedCurrencies } from 'hooks/useCurrentUserAcceptedCurrencies';
import { LIFECYCLE, useLifecycle } from 'hooks/useLifecycle';

import { useCurrentUserCurrencies } from './useCurrentUserCurrencies';

export const useReferenceCurrencyForSale = () => {
  const {
    walletPreferences: { onlyShowFiatCurrency, enabledWallets },
  } = useCurrentUserContext();
  const { fiatCurrency, cryptocurrency } = useCurrentUserCurrencies();
  const { acceptedCurrencies } = useCurrentUserAcceptedCurrencies();
  const {
    update: storeReferenceCurrencyForSale,
    loading,
    lifecycle,
  } = useLifecycle();

  const update = useCallback(
    (value: SupportedCurrency) => {
      storeReferenceCurrencyForSale(LIFECYCLE.referenceCurrencyForSale, value);
    },
    [storeReferenceCurrencyForSale]
  );
  const referenceCurrencyForSale = useMemo(() => {
    if (!enabledWallets) return SupportedCurrency.WEI;
    if (onlyShowFiatCurrency) return fiatCurrency;
    switch (acceptedCurrencies) {
      case AcceptedCurrenciesValue.FIAT:
        return fiatCurrency;
      case AcceptedCurrenciesValue.CRYPTO:
        return cryptocurrency;
      case AcceptedCurrenciesValue.BOTH:
        return lifecycle?.referenceCurrencyForSale || fiatCurrency;
      default:
    }
    return fiatCurrency;
  }, [
    acceptedCurrencies,
    cryptocurrency,
    enabledWallets,
    fiatCurrency,
    lifecycle?.referenceCurrencyForSale,
    onlyShowFiatCurrency,
  ]);

  return {
    update,
    loading,
    referenceCurrencyForSale,
  };
};
